import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { ProfileConsumer, getUtmSource } from 'providers/profile.provider';
import { PartnerLogo, PartnerHeaderStyle, DefaultHeaderStyle, LoadingContainer } from './layouts';
import { useProduct } from 'providers/product.provider';
import { PRE_APPROVED_PRODUCTS_NAME } from 'constants/constants';
import bizLogo from 'assets/img/biz-capital-logo-2019.png';

type HeaderLayoutProps = {
    isPartner: boolean,
    partnerLogo?: string,
};

const HeaderLayout: React.FC<HeaderLayoutProps> = ({ isPartner, partnerLogo }): JSX.Element => {
    const { isPreApproved } = useProduct();

    const isPreApprovedProduct = () => isPreApproved || PRE_APPROVED_PRODUCTS_NAME.includes(getUtmSource());

    if (isPreApprovedProduct()) {
        return (
            <nav className="header">
                <div className="inner">
                    {isPartner && <PartnerLogo url={partnerLogo} />}
                    {!isPartner && <img src={bizLogo} className="bizcap-logo" />}
                </div>
            </nav>
        )
    }

    if (isPartner) {
        return <PartnerHeaderStyle partnerUrl={partnerLogo} />;
    }

    return (
        <DefaultHeaderStyle />
    );
};

const Header: React.FC<RouteComponentProps> = (): JSX.Element => (
    <ProfileConsumer>
        {({ isPartner, logo }) => (
            isPartner === null
                ? <LoadingContainer />
                : <HeaderLayout isPartner={isPartner} partnerLogo={logo} />
        )}
    </ProfileConsumer>
);

export default withRouter(Header);
